import service from "../service";

const actions = {
  async getAll({ state, commit }, payload) {
    try {
      let sortBy = state.sortBy;
      let sortOrder = state.sortOrder;
      let searchQuery = state.searchQuery;

      commit("setItem", { resource: "gridList", payload: [] });
      let searchObject = {
        siteId: payload.siteId,
      };
      if (searchQuery) {
        searchObject = { ...searchObject, searchText: searchQuery };
      }
      const results = await service.getAll(searchObject);
      commit("setItem", { resource: "gridList", payload: results });
    } catch (e) {
      state.tblLoader = false;
    }
  },
  async getById({ commit }, params) {
    const result = await service.getById(params);
    commit("setItem", { resource: "plan", payload: result });
    return result;
  },
  async getCategoryOptions({ commit }) {
    const result = await service.getCategoryOptions();
    commit("setItem", { resource: "categoryNames", payload: result });
    return result;
  },
  async updatePlan(_, plan) {
    const response = await service.updatePlan(plan);
    return response;
  },

  async updateStatus(_, params) {
    return await service.updateStatus(params);
  },

  async planStoreMapping(_, params) {
    await service.planStoreMapping(params);
  },

  async getModuleMasterList({ commit }, params) {
    try {
      commit("setItem", { resource: "isLoading", payload: true });
      const response = await service.getModuleMasterList(params);
      const planPermissions = await service.getPlanModulePermissionById(params);
      commit("setItem", { resource: "isLoading", payload: false });
      return { response: response, planPermissions: planPermissions };
    } catch (error) {
      commit("setItem", { resource: "isLoading", payload: false });
      return { response: [], planPermissions: [] };
    }
  },

  async getPlanModulePermissionById(_, params) {
    const response = await service.getPlanModulePermissionById(params);
    return response;
  },

  async planModuleMapping(_, params) {
    const response = await service.planModuleMapping(params);
    return response;
  },
};

export default actions;
